/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { slug } from '../common';
import addApiRequestsParams from './extend/addApiRequestsParams';
import addControlsToReviewsPageHero from './extend/addControlsToReviewsPageHero';
import addCreateReviewOnTagsPages from './extend/addCreateReviewOnTagsPages';
import addFollowedReviews from './extend/addFollowedReviews';
import addReviewControls from './extend/addReviewControls';
import addReviewEditControls from './extend/addReviewEditControls';
import addReviewFeatureAlert from './extend/addReviewFeatureAlert';
import addReviewsNav from './extend/addReviewsNav';
import addReviewsState from './extend/addReviewsState';
import addReviewsToArticlePage from './extend/addReviewsToArticlePage';
import addReviewsToHomePage from './extend/addReviewsToHomePage';
import addUserReviewsToProfile from './extend/addUserReviewsToProfile';
import customizeReviewPosts from './extend/customizeReviewPosts';
import enableDraftSaving from './extend/enableDraftSaving';
import enhanceArticleSearch from './extend/enhanceArticleSearch';
import extendBookshelf from './extend/extendBookshelf';
import handleCustomErrors from './extend/handleCustomErrors';
import handleReviewEdits from './extend/handleReviewEdits';
import handleReviewPost from './extend/handleReviewPost';
import homeTagsLinkToReviews from './extend/homeTagsLinkToReviews';
import reviewArticleHero from './extend/reviewArticleHero';
import reviewsTour from './extend/reviewsTour';
import setComposerHeight from './extend/setComposerHeight';
import setupRouting from './extend/setupRouting';
import useReviewItemInDiscussionList from './extend/useReviewItemInDiscussionList';
import addControlsToArticleSliderItem from './extend/addControlsToArticleSliderItem';
import addReviewsToLiteraryWorkPage from './extend/addReviewsToLiteraryWorkPage';

/*
 * This extension copies and overrides code from flarum/core and flarum/tags. Every such place is
 * marked "CORE_CODE_OVERRIDE"; grep for it and re-check those against every core update.
 *
 * Last check: flarum/core v1.7.2.
 */

app.initializers.add(
	slug,
	() => {
		addApiRequestsParams();
		addControlsToReviewsPageHero();
		addControlsToArticleSliderItem();
		addCreateReviewOnTagsPages();
		addFollowedReviews();
		addReviewControls();
		addReviewEditControls();
		addReviewFeatureAlert();
		addReviewsNav();
		addReviewsState();
		addReviewsToArticlePage();
		addReviewsToLiteraryWorkPage();
		addReviewsToHomePage();
		addUserReviewsToProfile();
		customizeReviewPosts();
		enableDraftSaving();
		enhanceArticleSearch();
		extendBookshelf();
		handleCustomErrors();
		handleReviewPost();
		handleReviewEdits();
		homeTagsLinkToReviews();
		reviewArticleHero();
		reviewsTour();
		setComposerHeight();
		setupRouting();
		useReviewItemInDiscussionList();
	},
	-2
);

// Named `extenders.ts` to avoid colliding with the `extend/` directory.
export { default as extend } from './extenders';
